<template>
  <b-modal centered v-model="isOpen" hide-footer hide-header>
		<div class="w-100 d-flex flex-column text-center p-4">
			<div>
				<img
          class="user-icon"
					src="@/assets/images/user_icon.png"
					alt="User Icon"
				/>
			</div>
			<h4 class="pb-2">Agent</h4>
			<p class="fs-18">You can export agent transactions or add/disable agent.</p>
			<div><b-button @click="exportLogs" class="font-bold mb-2 w-50 fs-15">Export Transaction Log</b-button></div>
			<div><b-button :disabled="!agentTransactionLogsModule.access.create && !agentTransactionLogsModule.access.update" @click="navigateToAgent" class="font-bold mb-2 w-50 fs-15" variant="primary">Add / Disable Agent</b-button></div>
			<div><b-button @click="isOpen = false" class="font-bold w-50 fs-15" variant="light">Close</b-button></div>
			<label v-if="!agentTransactionLogsModule.access.create && !agentTransactionLogsModule.access.update" class="form-label small fw-bold text-danger" style="margin-top: 15px; font-style: italic;">Note: Your access is limited. You cannot add/disable an Agent.</label>
		</div>
  </b-modal>
</template>

<script>
import { exportMethods, erpUserRolesMethods } from "@/state/helpers";
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'

export default {
	name: "agent-menu",
	props: ["value"],
	data() {
		return {
			agentTransactionLogsModule: {
				access: {
					create: true,
					update: true
				}
			}
		};
	},
	computed: {
		isOpen: {
			get(){
				return this.value
			},
			set(value){
				this.$emit('input', value);
			}
		}
	},
	methods: {
		...exportMethods,
		...erpUserRolesMethods,
		exportLogs(){
			this.isOpen = false;
			var params = {
				module: 'agent_transactions',
				email: JSON.parse(localStorage.getItem('userData')).email
			}
			this.exportReport(params)
				.then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
				.catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
		},
		navigateToAgent(){
			this.isOpen = false;
			if(this.$route.name != 'Agent'){
				this.$router.push({ name: 'Agent' });
			}
		}
	},
	async mounted() {
		// get the module access for checking if user has create, read, update, and/or delete access
		await getModuleAccess('Reports', 'Agent Transaction Logs')
        .then((access) => this.agentTransactionLogsModule.access = access);
	}
}
</script>

<style>
.font-bold {
	font-weight: bold;
}

.fs-15 {
	font-size: 16px;
}

.user-icon {
  width: 120px;
  height: auto;
}

.fs-18 {
  font-size: 18px;
}
</style>